import { Moment } from 'moment';
import { API_URI, apiGet } from './index';

const favourability = {
    getAll: async (projectId: number, startDate: Moment, endDate: Moment, streamIds: number[]) => {
        const data = await apiGet(`${API_URI}/api/favourability/getall?projectId=${projectId}&startDate=${startDate.format("DD MMM YYYY HH:mm:ss")}&endDate=${endDate.format("DD MMM YYYY HH:mm:ss")}&streamIds=${streamIds.join(',')}`)
        return data;
    }
}

export default favourability;